import { createSlice } from "@reduxjs/toolkit";
import { fetchInStock } from "./thunk";

interface MyTeamState {
  List: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: MyTeamState = {
  List: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const InStockSlice = createSlice({
  name: "InStock",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInStock.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInStock.fulfilled, (state, action) => {
        state.loading = false;
        state.List = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchInStock.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message ||
          "Failed to fetch Field Engineer In Stock";
      });
  },
});

export default InStockSlice.reducer;
